import { makeStyles, createStyles } from '@material-ui/core/styles';

const useHomePageStyles = makeStyles(() => createStyles({
  homeTileGrid: {
    minHeight: '11rem',
  },
}));

export default useHomePageStyles;
